var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEnUsWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 18.6665C15.0851 18.6665 18.6669 15.0848 18.6669 10.6665C18.6669 6.24822 15.0851 2.6665 10.6668 2.6665C6.24842 2.6665 2.66663 6.24822 2.66663 10.6665C2.66663 15.0848 6.24842 18.6665 10.6668 18.6665Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 10.6665H18.6669",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7436 10.6665C13.5924 13.592 12.5149 16.3937 10.6667 18.6665C8.81843 16.3937 7.74086 13.592 7.58972 10.6665C7.74086 7.74099 8.81843 4.93931 10.6667 2.6665C12.5149 4.93931 13.5924 7.74099 13.7436 10.6665V10.6665Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_1750)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_383_1750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10H27V24H6V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10H27V11.0769H6V10Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.1538H27V13.2308H6V12.1538Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.3077H27V15.3846H6V14.3077Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16.4615H27V17.5385H6V16.4615Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18.6154H27V19.6923H6V18.6154Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20.7692H27V21.8462H6V20.7692Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 22.9231H27V24H6V22.9231Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10H16.6385V17.5371H6V10Z",
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00656 10.7007L6.90975 10.4028L6.81399 10.7007H6.50012L6.75441 10.8848L6.65652 11.1827L6.90975 10.9976L7.16403 11.1827L7.06615 10.8848L7.32043 10.7007H7.00656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7706 10.7007L8.67378 10.4028L8.57696 10.7007H8.26416L8.51738 10.8848L8.42056 11.1827L8.67378 10.9976L8.927 11.1827L8.83018 10.8848L9.08341 10.7007H8.7706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5346 10.7007L10.4378 10.4028L10.341 10.7007H10.0271L10.2814 10.8848L10.1846 11.1827L10.4378 10.9976L10.691 11.1827L10.5942 10.8848L10.8474 10.7007H10.5346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2976 10.7007L12.2008 10.4028L12.105 10.7007H11.7912L12.0455 10.8848L11.9476 11.1827L12.2008 10.9976L12.4551 11.1827L12.3572 10.8848L12.6115 10.7007H12.2976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1212 10.8848L14.3755 10.7007H14.0617L13.9648 10.4028L13.868 10.7007H13.5552L13.8084 10.8848L13.7116 11.1827L13.9648 10.9976L14.2181 11.1827L14.1212 10.8848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8853 10.8848L16.1385 10.7007H15.8257L15.7289 10.4028L15.6321 10.7007H15.3182L15.5725 10.8848L15.4757 11.1827L15.7289 10.9976L15.9821 11.1827L15.8853 10.8848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79176 11.1582L7.69494 11.4561H7.38214L7.63536 11.6402L7.53854 11.9381L7.79176 11.7541L8.04499 11.9381L7.94817 11.6402L8.20245 11.4561H7.88858L7.79176 11.1582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65262 11.4561L9.5558 11.1582L9.45898 11.4561H9.14618L9.3994 11.6402L9.30258 11.9381L9.5558 11.7541L9.80902 11.9381L9.7122 11.6402L9.96543 11.4561H9.65262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4156 11.4561L11.3198 11.1582L11.223 11.4561H10.9092L11.1634 11.6402L11.0656 11.9381L11.3198 11.7541L11.5731 11.9381L11.4762 11.6402L11.7295 11.4561H11.4156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1796 11.4561L13.0828 11.1582L12.9871 11.4561H12.6732L12.9264 11.6402L12.8296 11.9381L13.0828 11.7541L13.336 11.9381L13.2392 11.6402L13.4935 11.4561H13.1796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9437 11.4561L14.8469 11.1582L14.75 11.4561H14.4372L14.6905 11.6402L14.5936 11.9381L14.8469 11.7541L15.1001 11.9381L15.0033 11.6402L15.2565 11.4561H14.9437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00656 12.2126L6.90975 11.9136L6.81399 12.2126L6.50012 12.2116L6.75441 12.3956L6.65652 12.6946L6.90975 12.5095L7.16403 12.6946L7.06615 12.3956L7.32043 12.2116L7.00656 12.2126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7706 12.2126L8.67378 11.9136L8.57696 12.2126L8.26416 12.2116L8.51738 12.3956L8.42056 12.6946L8.67378 12.5095L8.927 12.6946L8.83018 12.3956L9.08341 12.2116L8.7706 12.2126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5346 12.2126L10.4378 11.9136L10.341 12.2126L10.0271 12.2116L10.2814 12.3956L10.1846 12.6946L10.4378 12.5095L10.691 12.6946L10.5942 12.3956L10.8474 12.2116L10.5346 12.2126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2976 12.2126L12.2008 11.9136L12.105 12.2126L11.7912 12.2116L12.0455 12.3956L11.9476 12.6946L12.2008 12.5095L12.4551 12.6946L12.3572 12.3956L12.6115 12.2116L12.2976 12.2126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0617 12.2126L13.9648 11.9136L13.868 12.2126L13.5552 12.2116L13.8084 12.3956L13.7116 12.6946L13.9648 12.5095L14.2181 12.6946L14.1212 12.3956L14.3755 12.2116L14.0617 12.2126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8853 12.3956L16.1385 12.2116L15.8257 12.2126L15.7289 11.9136L15.6321 12.2126L15.3182 12.2116L15.5725 12.3956L15.4757 12.6946L15.7289 12.5095L15.9821 12.6946L15.8853 12.3956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79176 12.6318L7.69494 12.9297H7.38214L7.63536 13.1138L7.53854 13.4117L7.79176 13.2276L8.04499 13.4117L7.94817 13.1138L8.20245 12.9297H7.88858L7.79176 12.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65262 12.9297L9.5558 12.6318L9.45898 12.9297H9.14618L9.3994 13.1138L9.30258 13.4117L9.5558 13.2276L9.80902 13.4117L9.7122 13.1138L9.96543 12.9297H9.65262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4156 12.9297L11.3198 12.6318L11.223 12.9297H10.9092L11.1634 13.1138L11.0656 13.4117L11.3198 13.2276L11.5731 13.4117L11.4762 13.1138L11.7295 12.9297H11.4156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1796 12.9297L13.0828 12.6318L12.9871 12.9297H12.6732L12.9264 13.1138L12.8296 13.4117L13.0828 13.2276L13.336 13.4117L13.2392 13.1138L13.4935 12.9297H13.1796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9437 12.9297L14.8469 12.6318L14.75 12.9297H14.4372L14.6905 13.1138L14.5936 13.4117L14.8469 13.2276L15.1001 13.4117L15.0033 13.1138L15.2565 12.9297H14.9437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00656 13.6862L6.90975 13.3872L6.81399 13.6862L6.50012 13.6851L6.75441 13.8692L6.65652 14.1671L6.90975 13.983L7.16403 14.1671L7.06615 13.8692L7.32043 13.6851L7.00656 13.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7706 13.6862L8.67378 13.3872L8.57696 13.6862L8.26416 13.6851L8.51738 13.8692L8.42056 14.1671L8.67378 13.983L8.927 14.1671L8.83018 13.8692L9.08341 13.6851L8.7706 13.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5346 13.6862L10.4378 13.3872L10.341 13.6862L10.0271 13.6851L10.2814 13.8692L10.1846 14.1671L10.4378 13.983L10.691 14.1671L10.5942 13.8692L10.8474 13.6851L10.5346 13.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2976 13.6862L12.2008 13.3872L12.105 13.6862L11.7912 13.6851L12.0455 13.8692L11.9476 14.1671L12.2008 13.983L12.4551 14.1671L12.3572 13.8692L12.6115 13.6851L12.2976 13.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0617 13.6862L13.9648 13.3872L13.868 13.6862L13.5552 13.6851L13.8084 13.8692L13.7116 14.1671L13.9648 13.983L14.2181 14.1671L14.1212 13.8692L14.3755 13.6851L14.0617 13.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8853 13.8692L16.1385 13.6851L15.8257 13.6862L15.7289 13.3872L15.6321 13.6862L15.3182 13.6851L15.5725 13.8692L15.4757 14.1671L15.7289 13.983L15.9821 14.1671L15.8853 13.8692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79176 14.1267L7.69494 14.4246H7.38214L7.63536 14.6086L7.53854 14.9066L7.79176 14.7225L8.04499 14.9066L7.94817 14.6086L8.20245 14.4246H7.88858L7.79176 14.1267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65262 14.4246L9.5558 14.1267L9.45898 14.4246H9.14618L9.3994 14.6086L9.30258 14.9066L9.5558 14.7225L9.80902 14.9066L9.7122 14.6086L9.96543 14.4246H9.65262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4156 14.4246L11.3198 14.1267L11.223 14.4246H10.9092L11.1634 14.6086L11.0656 14.9066L11.3198 14.7225L11.5731 14.9066L11.4762 14.6086L11.7295 14.4246H11.4156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1796 14.4246L13.0828 14.1267L12.9871 14.4246H12.6732L12.9264 14.6086L12.8296 14.9066L13.0828 14.7225L13.336 14.9066L13.2392 14.6086L13.4935 14.4246H13.1796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9437 14.4246L14.8469 14.1267L14.75 14.4246H14.4372L14.6905 14.6086L14.5936 14.9066L14.8469 14.7225L15.1001 14.9066L15.0033 14.6086L15.2565 14.4246H14.9437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00656 15.1811L6.90975 14.8821L6.81399 15.1811L6.50012 15.18L6.75441 15.3641L6.65652 15.663L6.90975 15.4779L7.16403 15.663L7.06615 15.3641L7.32043 15.18L7.00656 15.1811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7706 15.1811L8.67378 14.8821L8.57696 15.1811L8.26416 15.18L8.51738 15.3641L8.42056 15.663L8.67378 15.4779L8.927 15.663L8.83018 15.3641L9.08341 15.18L8.7706 15.1811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5346 15.1811L10.4378 14.8821L10.341 15.1811L10.0271 15.18L10.2814 15.3641L10.1846 15.663L10.4378 15.4779L10.691 15.663L10.5942 15.3641L10.8474 15.18L10.5346 15.1811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2976 15.1811L12.2008 14.8821L12.105 15.1811L11.7912 15.18L12.0455 15.3641L11.9476 15.663L12.2008 15.4779L12.4551 15.663L12.3572 15.3641L12.6115 15.18L12.2976 15.1811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0617 15.1811L13.9648 14.8821L13.868 15.1811L13.5552 15.18L13.8084 15.3641L13.7116 15.663L13.9648 15.4779L14.2181 15.663L14.1212 15.3641L14.3755 15.18L14.0617 15.1811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8853 15.3641L16.1385 15.18L15.8257 15.1811L15.7289 14.8821L15.6321 15.1811L15.3182 15.18L15.5725 15.3641L15.4757 15.663L15.7289 15.4779L15.9821 15.663L15.8853 15.3641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79176 15.6003L7.69494 15.8982H7.38214L7.63536 16.0822L7.53854 16.3801L7.79176 16.1961L8.04499 16.3801L7.94817 16.0822L8.20245 15.8982H7.88858L7.79176 15.6003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65262 15.8982L9.5558 15.6003L9.45898 15.8982H9.14618L9.3994 16.0822L9.30258 16.3801L9.5558 16.1961L9.80902 16.3801L9.7122 16.0822L9.96543 15.8982H9.65262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4156 15.8982L11.3198 15.6003L11.223 15.8982H10.9092L11.1634 16.0822L11.0656 16.3801L11.3198 16.1961L11.5731 16.3801L11.4762 16.0822L11.7295 15.8982H11.4156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1796 15.8982L13.0828 15.6003L12.9871 15.8982H12.6732L12.9264 16.0822L12.8296 16.3801L13.0828 16.1961L13.336 16.3801L13.2392 16.0822L13.4935 15.8982H13.1796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9437 15.8982L14.8469 15.6003L14.75 15.8982H14.4372L14.6905 16.0822L14.5936 16.3801L14.8469 16.1961L15.1001 16.3801L15.0033 16.0822L15.2565 15.8982H14.9437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00656 16.6546L6.90975 16.3557L6.81399 16.6546L6.50012 16.6536L6.75441 16.8376L6.65652 17.1355L6.90975 16.9515L7.16403 17.1355L7.06615 16.8376L7.32043 16.6536L7.00656 16.6546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7706 16.6546L8.67378 16.3557L8.57696 16.6546L8.26416 16.6536L8.51738 16.8376L8.42056 17.1355L8.67378 16.9515L8.927 17.1355L8.83018 16.8376L9.08341 16.6536L8.7706 16.6546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5346 16.6546L10.4378 16.3557L10.341 16.6546L10.0271 16.6536L10.2814 16.8376L10.1846 17.1355L10.4378 16.9515L10.691 17.1355L10.5942 16.8376L10.8474 16.6536L10.5346 16.6546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2976 16.6546L12.2008 16.3557L12.105 16.6546L11.7912 16.6536L12.0455 16.8376L11.9476 17.1355L12.2008 16.9515L12.4551 17.1355L12.3572 16.8376L12.6115 16.6536L12.2976 16.6546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0617 16.6546L13.9648 16.3557L13.868 16.6546L13.5552 16.6536L13.8084 16.8376L13.7116 17.1355L13.9648 16.9515L14.2181 17.1355L14.1212 16.8376L14.3755 16.6536L14.0617 16.6546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8853 16.8376L16.1385 16.6536L15.8257 16.6546L15.7289 16.3557L15.6321 16.6546L15.3182 16.6536L15.5725 16.8376L15.4757 17.1355L15.7289 16.9515L15.9821 17.1355L15.8853 16.8376Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_1750"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 14.0003,
    height: 14,
    rx: 6.99998,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_383_1750"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnUsWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/en-us-white.abe83271.svg";
export { ForwardRef as ReactComponent };